export const PACKAGES_REWARDS_DISABLED_BANNER_TEXT =
  "Rewards redemptions are temporarily unavailable. Card purchases will still earn rewards normally.";
